import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Problems" className="border-y border-grape/10 bg-white/70" data-id="element-116" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-117" data-mp="26xmt34jwpsfl">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-118" data-mp="2bvy4hjpuoazx">
          Do Any Of These Sound Like You?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-119" data-mp="21z37j5986inr">
          You work with injured athletes and want to help them recover properly, but every time you
          try to create a protocol you end up lost between exercise selection, progression criteria
          and return-to-sport timelines that lead nowhere.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-120" data-mp="3ibi6o8v5xt4p">
          It is not lack of talent. It is not lack of effort. It is lack of a visual system.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-121" data-mp="1yyke7feklc1r">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-122" data-mp="1u12coa2vtz3s" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-123" data-mp="1p2heshb3rrii">
                {p.emoji}
              </span>
              <div data-id="element-124" data-mp="1k5qxjqnkapvi">
                <h3 className="text-sm font-bold text-plum" data-id="element-125" data-mp="30he7q2aer0v5">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-126" data-mp="30jh5x9lps0ay">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-127" data-mp="1t5y84j1wub1y">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-128" data-mp="1t79duoex1svp">
            ✨ If you answered YES to any of these, we have the solution.
          </p>
          <p className="mt-3 text-lg font-semibold text-blush-deep" data-id="element-129" data-mp="2274sx4ble810">
            Day 30 can sound completely different.
          </p>
        </div>
      </div>
    </section>;
}